import { Box, Button, Grid, InputLabel, makeStyles, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import EditIcon from '@material-ui/icons/Edit';
import CustomSelectMulti from '../../../../Components/CustomSelectMulti';
import DataService from '../../../../Service';
import PanelDrawer from './PanelDrawer';
import { useDispatch, useSelector } from 'react-redux';
import StepperService from '../StepperService';
import { mappedKeyJSON } from '../MappedKeyJSON';
import Header from '../header';

const useStyles = makeStyles(() => ({
    labelText: {
        color: '#4D4F5C',
        fontSize: '16px',
        lineHeight: '22px',
    },
}))


function PanelAccess(props) {
    const classes = useStyles();
    const global_data_common = useSelector((state) => state.commonReducer);
    const global_data = useSelector((state) => state.stepperReducer);
    const dispatch = useDispatch();

    const [editFlag, setEditFlag] = useState(false);
    const [partnerRolesArr, setPartnerRolesArr] = useState([]);
    const [partnerDummyRoleArr, setPartnerDummyRoleArr] = useState([]);
    const [organisationPanelsAttribute, setOrganisationPanelsAtribute] = useState([]);
    const [organisationPanelsArr, setOrganisationPanelsArr] = useState([]);
    const [currentId, setCurrentId] = useState(0);
    const [currentName, setCurrentName] = useState('');
    const [drawerFlag, setDrawerFlag] = React.useState(false);


    const onChangeMultiItem = (params) => {

    }

    useEffect(() => {
    window.scrollTo(0,0);
        organisationPanelsArr.length = 0;
        setOrganisationPanelsArr(organisationPanelsArr.concat(global_data_common.partnerDropdowns[mappedKeyJSON.OrganisationPanels]))
        partnerDummyRoleArr.length = 0;
        setPartnerDummyRoleArr(partnerDummyRoleArr.concat(global_data_common.partnerDropdowns[mappedKeyJSON.Role]))

        DataService.getDirectData("/partner_role_organisation_maps", { partner_profile_id: global_data.partner_profile }).then((response) => {
            console.log(`response`, response)
            StepperService.getValueFromArrayForCombobox1(response.organisation_panels, global_data_common.partnerDropdowns[mappedKeyJSON.OrganisationPanels], setOrganisationPanelsAtribute, organisationPanelsAttribute)
            StepperService.getValueFromArrayForCombobox1(response.partner_roles, global_data_common.partnerDropdowns[mappedKeyJSON.Role], setPartnerRolesArr, partnerRolesArr, dispatch, "role", global_data)
        })
    }, [])

    const openDrawerById = (obj) => {
        setEditFlag(true);
        setCurrentId(obj.id)
        setCurrentName(obj.value)
    }

    const toggleDrawer = (flag) => (event) => {
        setDrawerFlag(flag);
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        // !open && props.parentCall(null)
    };

    const onBack = () => {
        props.parentHandleNext(props.activeIndex - 1)
    }
    const onNext = () => {
        props.parentHandleNext(props.activeIndex + 1)
    }
    return <Box>
        <Grid container direction="row" alignItems="flex-start" style={{ padding: 20 }}>
            <Grid item xs={8}>
                <Grid container direction="row" alignItems="center" style={{ marginBottom: 20 }}>
                    <Grid item xs={4}>
                        <Typography variant="h2">Type of partner</Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <CustomSelectMulti id="partnerRolesArr" isDisabled="true" itemArr={partnerDummyRoleArr}
                            placeholder={<Typography variant="h2">Select partner</Typography>}
                            value={partnerRolesArr} />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="center" style={{ marginBottom: 20 }}>
                    <Grid item xs={4}>
                        <Typography variant="h2">Organization panels</Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <CustomSelectMulti id="organisation_panels_attributes" isDisabled="true" itemArr={organisationPanelsArr}
                            placeholder={<Typography variant="h2">Select organization panels</Typography>}
                            value={organisationPanelsAttribute} />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="flex-start" style={{ marginBottom: 20 }}>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={8}>
                        <Box mb={3}>
                            <Typography variant="h2" color="initial">Panel access</Typography>
                        </Box>
                        {
                            organisationPanelsAttribute.length > 0 && organisationPanelsAttribute.map((option) => {
                                return <Box>
                                    <Grid container direction="row" alignItems="flex-start" style={{ marginBottom: 20 }}>
                                        <Grid item xs={8}>
                                            <Typography variant="h2" color="initial">{option.value}</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Button disableElevation variant="outlined" style={{ textTransform: 'none' }} startIcon={<EditIcon />} onClick={(e) => { setDrawerFlag(true); openDrawerById(option) }}>
                                                Edit
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            })
                        }


                    </Grid>
                </Grid>
            </Grid>

        </Grid>
        {
            drawerFlag &&
            <PanelDrawer parentToggleDrawer={toggleDrawer} setDrawerFlag={setDrawerFlag} drawerFlag={drawerFlag} orgId={currentId} orgName={currentName} />
        }
        <Header isBack={true} saveBtnTitle={'Save and proceed'} parentcall={onNext} parentBackCall={onBack} />
    </Box>
}

export default PanelAccess
